// Sized to content, but grows to soak up leftover width so the grid fills the
// panel on wide screens instead of stopping short.
export const COLUMN_WIDTH = "minmax(max-content, auto)";
export const COLUMN_LAYOUT_VERSION = "v2";
export const COLUMN_MIN_WIDTH = 50;
